import React from "react";

import emptySet from 'Assets/img/icon/empty-set-mathematical-symbol.png';
import setEmpty from 'Assets/img/icon/setempty.svg';
import create from 'Assets/img/cages/create.svg';
import email from 'Assets/img/add__item/email.svg';
import length from 'Assets/img/cages/length.svg';
import quantity from 'Assets/img/cages/quantity.svg';
import weight from 'Assets/img/cages/weight.svg';
import writer from 'Assets/img/cages/writer.svg';
import xDetails from 'Assets/img/add__item/blue x details.svg';
import yDetails from 'Assets/img/add__item/y.svg';
import details from 'Assets/img/nets/details.svg';

import NetShape from "../shape";
import { netErrorTypes, sidesErrorsX, sidesErrorsY, gapOptions, netXLengthMax, netXLengthMin, netYLengthMax, netYLengthMin  } from 'Constants/net-constants';
import { useAppSelector } from "Redux/hooks";
import { DebounceInput } from "react-debounce-input";
import { useTranslation } from "react-i18next";
import { calculate_partitions } from "../../utils";

function NetMobileContent({
  isSaving,
  edit,
  shapeObj,
  setRescaleFactor,
  partitionX,
  setPartitionX,
  partitionY,
  setPartitionY,
  labelingPoints,
  setLabelingPoints,
  setShape,
  orderItem,
  setOrderItem,
  stageRef,
  getDiameter,
  isLoading,
  customizeView,
  setXUnits,
  setYUnits,
  errorsText,
  addError,
  removeError,
  validateVals,
  validateMidVals,
  onX1Change,
  onX2Change,
  onX3Change,
  onY1Change,
  onY2Change,
  onY3Change,
  checkLengths,
  showStandard,
  setShowStandard,
  toggleUniformGap,
  toggleUniformDiameter,
  edgeChanged_X,
  setEdgeChanged_X,
  edgeChanged_Y,
  setEdgeChanged_Y,
  initiateImage,
  saveNet,
  netNumber,
  setNetNumber,
}: any) {
  const steelDiameters = useAppSelector(state => state.steelType.steelDiameters);
  const steelTypes = useAppSelector(state => state.steelType.steelTypes);
  const { t } = useTranslation(["newOrder", "common", "measurements"]);
  const updateLength = (axis: "x" | "y", raw: string) => {
    const length = Math.abs(parseInt(raw));
    [netErrorTypes.MIN, netErrorTypes.MAX, netErrorTypes.MAXMIN].forEach(removeError);
    setShape({...shapeObj, [axis + "_length"]: length});
    const parts = calculate_partitions(shapeObj[axis + "_gap"], length, shapeObj[axis + "_diameter"]?.steel_diameter);
    (axis === "x" ? setPartitionX : setPartitionY)(parts);
    (axis === "x" ? sidesErrorsX : sidesErrorsY).forEach(removeError);
  };
  const updateGap = (axis: "x" | "y", raw: string) => {
    const gap = parseInt(raw);
    const axes = showStandard ? ["x", "y"] : [axis];
    const next = {...shapeObj};
    axes.forEach(direction => {
      next[direction + "_gap"] = gap;
      (direction === "x" ? setPartitionX : setPartitionY)(calculate_partitions(gap, shapeObj[direction + "_length"], shapeObj[direction + "_diameter"]?.steel_diameter));
      (direction === "x" ? sidesErrorsX : sidesErrorsY).forEach(removeError);
    });
    setShape(next);
  };
  const handleNetTypeToggle = (standard: boolean) => {
    if (standard === showStandard) return;

    setShowStandard(standard);

    if (standard) {
      if (!customizeView?.uniformDiameter) toggleUniformDiameter();
      if (!customizeView?.uniformGap) toggleUniformGap();

      const nextShape = {
        ...shapeObj,
        y_gap: shapeObj.x_gap,
        y_diameter: shapeObj.x_diameter,
      };
      setShape(nextShape);
      setPartitionX(
        calculate_partitions(
          nextShape.x_gap,
          nextShape.x_length,
          nextShape.x_diameter?.steel_diameter
        )
      );
      setPartitionY(
        calculate_partitions(
          nextShape.y_gap,
          nextShape.y_length,
          nextShape.y_diameter?.steel_diameter
        )
      );
    } else {
      if (customizeView?.uniformDiameter) toggleUniformDiameter();
      if (customizeView?.uniformGap) toggleUniformGap();
    }
  };

  return (
    <>
    <label className="editor-mobile-name">{t("net name", { ns: "tool" })}
      <input type="text" maxLength={20} data-editor-field="name" value={shapeObj.name || ""} onChange={event => setShape({...shapeObj, name: event.target.value})} />
    </label>
      <section className="mobile-net-type" aria-labelledby="mobile-net-type-heading">
        <h2 id="mobile-net-type-heading">{t("net type", { ns: "tool" })}</h2>
        <div
          className="mobile-net-type__options"
          role="group"
          aria-label={t("net type", { ns: "tool" })}
        >
          <button
            type="button"
            className={showStandard ? "is-active" : ""}
            aria-pressed={showStandard}
            onClick={() => handleNetTypeToggle(true)}
          >
            {t("symmetric", { ns: "common" })}
          </button>
          <button
            type="button"
            className={!showStandard ? "is-active" : ""}
            aria-pressed={!showStandard}
            onClick={() => handleNetTypeToggle(false)}
          >
            {t("asymmetric", { ns: "common" })}
          </button>
        </div>
      </section>      {/* <!-- type 2d or 3d  --> */}
      {/* <div className="w-xs-100 d-flex justify-content-between align-items-center bg-white p-3">
        <p className="big__para text-center text-capitalize text-dark">type</p>
        <div className="btn-group" role="group" aria-label="Basic example">
          <button type="button" className="btn text-dark para text-uppercase mid__bold" id="base__btn">3d</button>
          <button type="button" className="btn para text-white text-uppercase mid__bold active">2d</button>
        </div>
      </div> */}
      {/* <!-- dark section  --> */}
      <div className="p-3 d-flex dark__head align-items-center bg_gradient">
        <span className="icon__wrap text-success d-flex align-items-center justify-content-center mr-3">
          <img src={create} alt="create icon"/>
        </span>
        <h2 className="black__wrap text-uppercase text-left text-white mb-0">{t("create shapes", { ns: "tool" })}</h2>
      </div>
      {/* <!-- preview and btn  --> */}
      <div className="bg-white p-4">
        {/* <!-- btn icon and heading  --> */}
        <div className="btn__icon__head d-flex justify-content-between">
          {/* <!-- icon and heading  --> */}
          <div className="icon__head d-flex align-items-center justify-content-center">
            <p className="big__para">{t("preview", { ns: "tool" })}</p>
          </div>
          {/* <!-- buttons  --> */}
          </div>
        {/* <!-- image image table  --> */}
        <div className="main__img__table mt-3 mt-sm-4 d-flex align-items-center justify-content-center px-2 py-3 rounded">
          {/* <!-- right image  --> */}
          {/* <div className="right__img w-xs-100 d-flex align-items-center p-3">
            <img className="netAddMainTableImage w-xs-95" src={netMain} alt="images right"/>
          </div> */}
          <NetShape
          isLoading={isLoading}
          shapeObj={shapeObj}
          setRescaleFactor={setRescaleFactor}
          partitionX={partitionX}
          setPartitionX={setPartitionX}
          partitionY={partitionY}
          setPartitionY={setPartitionY}
          labelingPoints={labelingPoints}
          setLabelingPoints={setLabelingPoints}
          setShape={setShape}
          stageRef={stageRef}
          customizeView={customizeView}
          setXUnits={setXUnits}
          setYUnits={setYUnits}
          errorsText={errorsText}
          addError={addError}
          removeError={removeError}
          validateVals={validateVals}
          validateMidVals={validateMidVals}
          onX1Change={onX1Change}
          onX2Change={onX2Change}
          onX3Change={onX3Change}
          onY1Change={onY1Change}
          onY2Change={onY2Change}
          onY3Change={onY3Change}
          checkLengths={checkLengths}
          showStandard={showStandard}
          edgeChanged_X={edgeChanged_X}
          setEdgeChanged_X={setEdgeChanged_X}
          edgeChanged_Y={edgeChanged_Y}
          setEdgeChanged_Y={setEdgeChanged_Y}
          initiateImage={initiateImage}
          />
        </div>
        {/* <!-- general size  --> */}
        <div className="sec__img__table">
          {/* Net Number */}
          <div className="icon__form d-flex justify-content-between py-3 border__bottom">
            {/* <!-- left section  --> */}
            <div className="left__sec d-flex align-items-center">
              {/* <!-- para  --> */}
              <p className="big__para text-capitalize">{t("net number", { ns: "tool" })}</p>
            </div>
            {/* <!-- right section  --> */}
            <div className="right__sec d-flex justify-content-end align-items-center w-xs-40">
              {/* <h6 className="big__tittle mb-0"></h6> */}
              <input
                type="text"
                className="form-control bg-white border-success"
                value={netNumber}
                onChange={(e) => {
                  if (e.target.value !== '' && e.target.value[0] === "N") {
                    setNetNumber(e.target.value);
                  }
                }}
              />
            </div>
          </div>
          {/* <!-- btn icon and heading  --> */}
          <div className="btn__icon__head d-flex justify-content-between py-3 border__bottom">
            {/* <!-- icon and heading  --> */}
            <div className="icon__head d-flex align-items-start justify-content-center">
              <span className="icon__wrap mr-3 text-dark">
                <img src={length} alt="length icon"/>
              </span>
              <p className="big__para">{t("net size", { ns: "tool" })}</p><span className="unit">({t("cm", { ns: "measurements" })})</span>
            </div>
            {/* <!-- right side form input  --> */}
            <div className="right__side w-xs-40 d-flex flex-column">
              {/* <!-- column  --> */}
              <div className="d-flex align-items-center">
                <h5 className="text-uppercase bold mr-2">X</h5>
                <DebounceInput
                type="number"
                debounceTimeout={700}
                className={"form-control bg-white border-success input__big"
                + (shapeObj.x_length < netXLengthMin || shapeObj.x_length >= netXLengthMax ? " error-input" : "")}
                data-editor-field="x_length" value={shapeObj.x_length || ''}
                onChange={(e) => updateLength("x", e.target.value)}/>
              </div>
              {/* <!-- column  --> */}
              <div className="d-flex align-items-center mt-2">
                <h5 className="text-uppercase bold mr-2">Y</h5>
                <DebounceInput
                type="number"
                debounceTimeout={700}
                className={"form-control bg-white border-success input__big"
                + (shapeObj.y_length < netYLengthMin || shapeObj.y_length >= netYLengthMax ? " error-input" : "")}
                data-editor-field="y_length" value={shapeObj.y_length || ''}
                onChange={(e) => updateLength("y", e.target.value)}/>
              </div>
            </div>
          </div>
          {/* <!-- Steel Type  --> */}
          <div className="icon__form d-flex justify-content-between pt-3">
            {/* <!-- left section  --> */}
            <div className="left__sec d-flex align-items-center">
              {/* <!-- icon  --> */}
              <div className="icon__wrap mr-1">
                <img src={setEmpty} alt="set icon"/>
              </div>
              {/* <!-- para  --> */}
              <p className="big__para text-capitalize">{t("steel type", { ns: "tool" })}</p>
            </div>
            {/* <!-- right section  --> */}
            <div className="right__sec d-flex justify-content-end align-items-center w-xs-60">
              {/* <h6 className="big__tittle mb-0"></h6> */}
              <select className="form-control ml-3 mid__bold"
              data-editor-field="steel_type" value={shapeObj.steel_type || ''}
              onChange={({target}) => {
                const stType = parseInt(target.value);
                if (stType in steelDiameters) {
                  setShape(
                    (prev: any) => ({
                      ...prev,
                      steel_type: parseInt(target.value),
                      x_diameter: steelDiameters[stType].find((item: any) => item.steel_diameter === prev.x_diameter?.steel_diameter),
                      y_diameter: steelDiameters[stType].find((item: any) => item.steel_diameter === prev.y_diameter?.steel_diameter),
                    })
                  );
                } else {
                  setShape((prev: any) => ({...prev, steel_type: stType}));
                }
              }}
              >
                {steelTypes.map((st: {id: number, name: string}) =>
                  <option key={'rebar-steeltype-options-' + st.id} value={st.id}>{st.name}</option>
                )}
              </select>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- x details  --> */}
      <div className="p-3 d-flex dark__head align-items-center justify-content-between  bg_gradient">
        {/* <!-- left side  --> */}
        <div className="left d-flex">
          <span className="img__wrap mr-2">
            <img src={xDetails} alt=""/>
          </span>
          <h2 className="black__wrap text-uppercase text-left text-white mb-0">{t("x details", { ns: "tool" })}</h2>
        </div>
        {/* <!-- right side  --> */}
        <div className="right">
          <p className="para text-white" style={{color: 'white!important'}}>x {shapeObj.x_length || ''}</p>
        </div>
      </div>
      {/* <!-- details content  --> */}
      <div className="p-3 py-4 bg-white">
        {/* <!-- diameter  --> */}
        <div className="icon__form d-flex justify-content-between border__bottom py-3">
          {/* <!-- left section  --> */}
          <div className="left__sec d-flex align-items-center">
            {/* <!-- icon  --> */}
            <div className="icon__wrap mr-3">
              <img src={emptySet} alt="set icon"/>
            </div>
            {/* <!-- para  --> */}
            <p className="big__para text-capitalize">{t("diameter", { ns: "tool" })}</p><span className="unit">({t("mm", { ns: "measurements" })})</span>
          </div>
          {/* <!-- right section  --> */}
          <div className="right__sec d-flex justify-content-end align-items-center w-xs-40">
            {/* <h6 className="big__tittle mb-0"></h6> */}
            <select className="form-control ml-3 mid__bold"
              data-editor-field="x_diameter" value={shapeObj.x_diameter ? shapeObj.x_diameter.id : ''}
              onChange={(e) => {
                const _diameter = getDiameter(parseInt(e.target.value));
                if (_diameter) {
                  setShape({...shapeObj, x_diameter: _diameter, ...(showStandard ? { y_diameter: _diameter } : {})});
                }
              }}
            >
              {shapeObj.steel_type in steelDiameters
              && steelDiameters[shapeObj.steel_type].map((reDi: any, index: number) =>
                <option key={'net-x-diameter-options-' + index} value={reDi.id}>{reDi.steel_diameter.toFixed(0)}</option>
              )}
            </select>
          </div>
        </div>
        {/* <!-- gap  --> */}
        <div className="icon__form d-flex justify-content-between border__bottom py-3">
          {/* <!-- left section  --> */}
          <div className="left__sec d-flex align-items-center">
            {/* <!-- icon  --> */}
            <div className="icon__wrap mr-3">
              <img src={email} alt="email icon"/>
            </div>
            {/* <!-- para  --> */}
            <p className="big__para text-uppercase">{t("gap", { ns: "tool" })}</p><span className="unit">({t("cm", { ns: "measurements" })})</span>
          </div>
          {/* <!-- right section  --> */}
          <div className="right__sec d-flex justify-content-end align-items-center w-xs-40">
            <select className="form-control form-control-sm bg-white"
            data-editor-field="x_gap" value={shapeObj.x_gap || ''}
            onChange={(e) => updateGap("x", e.target.value)
            }
            >
              {gapOptions.map((item, index) =>
                <option key={"gap-options-1"+index}>{item}</option>
              )}
            </select>
          </div>
        </div>
        <div className="img__table py-5 net-details"
        style={{backgroundImage: 'url(' + details + ')'}}>
          <div className="input__container row">
            {/* <!-- column  --> */}
            <div className="col-4 d-flex align-items-center">
              <label className="text-uppercase mr-2">x2</label>
              <DebounceInput
                type="number"
                className="form-control bg-white border-success input__big"
                value={partitionX._2 || ''}
                debounceTimeout={300}
                onChange={onX2Change}
              />
            </div>
            {/* <!-- column  --> */}
            <div className="col-4 d-flex align-items-center">
              <label className="text-uppercase mr-2">x1</label>
              <DebounceInput
                type="number"
                className="form-control bg-white border-success input__big"
                value={partitionX._1.toFixed(0) || ''}
                debounceTimeout={300}
                onChange={onX1Change}
              />
            </div>
            {/* <!-- column  --> */}
            <div className="col-4 d-flex align-items-center">
              <label className="text-uppercase mr-2">x3</label>
              <DebounceInput
              type="number"
              className="form-control bg-white border-success input__big"
              value={partitionX._3 || ''}
              debounceTimeout={300}
              onChange={onX3Change}
              />
            </div>
          </div>
        </div>
      </div>
      {/* <!-- y details  --> */}
      <div className="p-3 d-flex dark__head align-items-center justify-content-between  bg_gradient">
        {/* <!-- left side  --> */}
        <div className="left d-flex align-items-center justify-content-center">
          <span className="img__wrap mr-2">
            <img className="yImg" src={yDetails} alt="y details"/>
          </span>
          <h2 className="black__wrap text-uppercase text-left text-white mb-0">{t("y details", { ns: "tool" })}</h2>
        </div>
        {/* <!-- right side  --> */}
        <div className="right">
          <p className="para text-white" style={{color: 'white!important'}}>x {shapeObj.y_length}</p>
        </div>
      </div>
      {/* <!-- details content  --> */}
      <div className="p-3 py-4 bg-white">
        {/* <!-- diameter  --> */}
        <div className="icon__form d-flex justify-content-between border__bottom py-3">
          {/* <!-- left section  --> */}
          <div className="left__sec d-flex align-items-center">
            {/* <!-- icon  --> */}
            <div className="icon__wrap mr-3">
              <img src={emptySet} alt="set icon"/>
            </div>
            {/* <!-- para  --> */}
            <p className="big__para text-capitalize">{t("diameter", { ns: "tool" })}</p><span className="unit">({t("mm", { ns: "measurements" })})</span>
          </div>
          {/* <!-- right section  --> */}
          <div className="right__sec d-flex justify-content-end align-items-center w-xs-40">
            {/* <h6 className="big__tittle mb-0"></h6> */}
            <select className="form-control ml-3 mid__bold"
              data-editor-field="y_diameter" value={shapeObj.y_diameter ? shapeObj.y_diameter.id : ''}
              onChange={(e) => {
                const _diameter = getDiameter(parseInt(e.target.value));
                if (_diameter) {
                  setShape({...shapeObj, y_diameter: _diameter, ...(showStandard ? { x_diameter: _diameter } : {})});
                }
              }}
            >
              {shapeObj.steel_type in steelDiameters
              && steelDiameters[shapeObj.steel_type].map((reDi: any, index: number) =>
                <option key={'net-y-diameter-options-' + index} value={reDi.id}>{reDi.steel_diameter.toFixed(0)}</option>
              )}
            </select>
          </div>
        </div>
        {/* <!-- gap  --> */}
        <div className="icon__form d-flex justify-content-between border__bottom py-3">
          {/* <!-- left section  --> */}
          <div className="left__sec d-flex align-items-center">
            {/* <!-- icon  --> */}
            <div className="icon__wrap mr-3">
              <img src={email} alt="email icon"/>
            </div>
            {/* <!-- para  --> */}
            <p className="big__para text-uppercase">{t("gap", { ns: "tool" })}</p><span className="unit">({t("cm", { ns: "measurements" })})</span>
          </div>
          {/* <!-- right section  --> */}
          <div className="right__sec d-flex justify-content-end align-items-center w-xs-40">
            <select className="form-control form-control-sm bg-white"
            data-editor-field="y_gap" value={shapeObj.y_gap || ''}
            onChange={(e) => updateGap("y", e.target.value)
            }
            >
              {gapOptions.map((item, index) =>
                <option key={"gap-options-1"+index}>{item}</option>
              )}
            </select>
          </div>
        </div>
        <div className="img__table py-5 net-details"
        style={{backgroundImage: 'url(' + details + ')'}}>
          <div className="input__container row">
            {/* <!-- column  --> */}
            <div className="col-4 d-flex align-items-center">
              <label className="text-uppercase mr-2">y2</label>
              <DebounceInput
              type="number"
              className="form-control bg-white border-success input__big"
              value={partitionY._2 || ''}
              debounceTimeout={300}
              onChange={onY2Change}
              />
            </div>
            {/* <!-- column  --> */}
            <div className="col-4 d-flex align-items-center">
              <label className="text-uppercase mr-2">y1</label>
              <DebounceInput
              type="number"
              className="form-control bg-white border-success input__big"
              value={partitionY._1.toFixed(0) || ''}
              debounceTimeout={300}
              onChange={onY1Change}
              />
            </div>
            {/* <!-- column  --> */}
            <div className="col-4 d-flex align-items-center">
              <label className="text-uppercase mr-2">y3</label>
              <DebounceInput
                type="number"
                className="form-control bg-white border-success input__big"
                value={partitionY._3 || ''}
                debounceTimeout={300}
                onChange={onY3Change}
              />
            </div>
          </div>
        </div>
      </div>
      {/* <!-- dark section  --> */}
      <div className="p-3 d-flex dark__head align-items-center  bg_gradient">
        <h2 className="black__wrap text-uppercase text-left text-white mb-0">{t("quantity and weight", { ns: "tool" })}</h2>
      </div>
      {/* <!-- quantity and weight section  --> */}
      <div className="p-3 p-sm-4 bg-white bottom__radius">
        {/* <!-- quantity  --> */}
        <div className="icon__form d-flex justify-content-between border__bottom pb-3">
          {/* <!-- left section  --> */}
          <div className="left__sec d-flex align-items-center">
            {/* <!-- icon  --> */}
            <div className="icon__wrap mr-3">
              <img src={quantity} alt="quantity icon"/>
            </div>
            {/* <!-- para  --> */}
            <p className="big__para text-capitalize">{t("quantity", { ns: "tool" })}</p>
          </div>
          {/* <!-- right section  --> */}
          <div className="right__sec d-flex justify-content-end align-items-center">
            <input type="text" className="form-control w-xs-30 bg-white mid__bold text-center"
              data-editor-field="quantity" aria-label={t("quantity", { ns: "tool" })} value={orderItem.quantity || ''}
              onChange={(e) => { removeError(netErrorTypes.AMOUNT); setOrderItem({...orderItem, quantity: parseInt(e.target.value)}); }}
            />
          </div>
        </div>
        {/* <!-- weight  --> */}
        <div className="icon__form d-flex justify-content-between py-3">
          {/* <!-- left section  --> */}
          <div className="left__sec d-flex align-items-center">
            {/* <!-- icon  --> */}
            <div className="icon__wrap mr-3">
              <img src={weight} alt="weight icon"/>
            </div>
            {/* <!-- para  --> */}
            <p className="big__para text-capitalize">{t("weight", { ns: "tool" })}</p><span className="unit">({t("kg", { ns: "measurements" })})</span>
          </div>
          {/* <!-- right section  --> */}
          <div className="right__sec d-flex justify-content-between align-items-center w-xs-40">
            <p className="big__para text-capitalize">{t("unit", { ns: "tool" })}</p>
            <p className="big__para text-capitalize">{shapeObj.unit_weight}</p>
          </div>
        </div>
        {/* <!-- total  --> */}
        <div className="icon__form d-flex justify-content-between pb-3 border__bottom">
          {/* <!-- left section  --> */}
          <div className="left__sec d-flex align-items-center">
          </div>
          {/* <!-- right section  --> */}
          <div className="right__sec d-flex justify-content-between align-items-center w-xs-40 total__big">
            <p className="big__para text-capitalize bold text-dark-500">{t("total", { ns: "tool" })}</p>
            <p className="big__para text-capitalize bold text-dark-500">{(Number(shapeObj.unit_weight || 0)*Number(orderItem.quantity || 0)).toFixed(1)}</p>
          </div>
        </div>
        {/* <!-- item notes  --> */}
        <div className="icon__form d-flex justify-content-between py-3">
          {/* <!-- left section  --> */}
          <div className="left__sec d-flex align-items-center">
            {/* <!-- icon  --> */}
            <div className="icon__wrap mr-3">
              <img src={writer} alt="writer icon"/>
            </div>
            {/* <!-- para  --> */}
            <p className="big__para text-capitalize">{t("notes", { ns: "tool" })}</p>
          </div>
        </div>
        {/* <!-- note pad  --> */}
        <div className="note__pad">
          <textarea className="form-control" style={{backgroundColor: '#F0F0F0'}} rows={5}
            value={orderItem.production_notes || ''}
            onChange={(e) => setOrderItem({...orderItem, production_notes: e.target.value})}
          ></textarea>
        </div>
        {/* <!-- add item btn  --> */}
        {errorsText.length > 0 && <div className="editor-validation-errors" role="alert">{errorsText.map((error: any) => <p key={error.errorType}>{error.message}</p>)}</div>}
      <div className="add__item__btn py-4 py-sm-5 d-flex justify-content-center">
          <button disabled={isSaving || isLoading || !shapeObj.x_diameter?.id || !shapeObj.y_diameter?.id} aria-busy={isSaving} onClick={saveNet} className="big__btn text-uppercase bold text-white">{isSaving ? t(edit ? "editor saving" : "editor adding", { ns: "tool" }) : (edit ? t("update", { ns: "common" }) : t("add item", { ns: "tool" }))}</button>
        </div>
      </div>
    </>
  );
}

export default NetMobileContent;
